module.exports = __webpack_public_path__ + "static/media/konnexsion-logo-master.866c1fbc.png";